var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChargerConditions(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 32,
    viewBox: "0 0 32 32",
    width: 32,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0h32v32h-32z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m16.8178442.00017094c-7.23384015 0-11.86273567 5.28361488-11.96274237 12.30760086h-4.26696541c-.24287446 0-.49527278.1394217-.49527278.3846125-.12381819.2451908-.12381819.4903816 0 .61538l7.31479786 9.4614682c.1238188.1249997.25239832.2307675.49527277.2307675.24287446 0 .37145519-.1057678.49527277-.2307675l7.31479786-9.4614682c.1238188-.1249984.1238188-.3701892 0-.61538-.1238176-.2451908-.371454-.3846125-.4952728-.3846125h-4.2669654c.0809578-9.27396925 4.7812872-11.33645362 5.8670775-12.1922171.2428744-.12499907.2428744-.11538376 0-.11538376zm7.2842424 8.99982906c-.1810643 0-.371659.06742055-.4955461.19262838l-7.3188351 9.47731632c-.1238859.2456015-.1143568.491203-.1143568.6164109.1238872.2456015.3716602.3852567.4955461.3852567h4.3836773c-.0810024 9.2895034-4.783926 11.3554437-5.8703156 12.2126394-.2430085.1252091-.2430085.115577 0 .115577 7.2378326 0 11.8692829-5.292465 11.9693448-12.3282164h4.1549637c.2430085 0 .4955461-.1396552.4955461-.3852567.2430085-.2456015.2382439-.4912018.1143568-.6164109l-7.3188351-9.47731632c-.1238859-.12520783-.3144805-.19262838-.4955461-.19262838z",
    fill: "#333"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChargerConditions);
export default __webpack_public_path__ + "static/media/Charger Conditions.db925e452f5e25967fd0d6f2c7319e44.svg";
export { ForwardRef as ReactComponent };